import { UseQueryOptions, useQuery } from "react-query";
import { APIError, APIResponse, post, API_URL_V1 } from "../api";

export interface AlertAccountData {
  AccountNumber: string;
  FullName: string;
  AvailableBalance: number;
  LedgerBalance: number;
}

function useAlertEnquiry(
  options?: UseQueryOptions<APIResponse, APIError>
) {
  const {
    isLoading: fetchingAlertAccount,
    isError: isAlertEnquiryError,
    data: alertEnquiryData,
    refetch,
    isFetching: isRefetchingAlertAccount,
  } = useQuery<APIResponse, APIError>(
    "alert-account-enquiry",
    () =>
      post(`${API_URL_V1}/accounts/enquiry`, {}, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    { 
      refetchOnWindowFocus: true, 
      refetchInterval: false, 
      retry: 1,
      select: (data) => {
        // Use data.Message if present, otherwise treat data itself as the source
        const raw = data.Message || data;
        console.log(raw);
        const normalized = {
          ...raw,
          AccountNumber: raw.Nuban || raw.AccountNumber || raw.accountNumber || "",
          AvailableBalance: (raw.AvailableBalance || raw.availableBalance || 0) / 100,
          LedgerBalance: (raw.LedgerBalance || raw.ledgerBalance || 0) / 100,
        };

        // Return structure compatible with UI expectation (using .Message)
        return {
          ...data,
          Message: normalized,
        };
      },
      ...options 
    }
  );

  return {
    fetchingAlertAccount,
    isAlertEnquiryError,
    alertEnquiryData,
    refetchAlertAccount: refetch,
    isRefetchingAlertAccount,
  };
}

export default useAlertEnquiry;
